import colors from 'tailwindcss/colors';

/**
 * Theme configuration
 */
export const themes = {
    // Default theme is required for theming system to work correctly!
    default: {
        primary: { DEFAULT: colors.indigo[600]}
    },
    // Rest of the themes will use the 'default' as the base theme
    brand: {
        primary: { DEFAULT: colors.yellow[600]}
    },
    teal: {
        primary: { DEFAULT: colors.teal[600]}
    },
    rose: {
        primary: { DEFAULT: colors.rose[600]}
    },
    purple: {
        primary: { DEFAULT: colors.purple[600]}
    },
    amber: {
        primary: { DEFAULT: colors.amber[600]}
    }
};
